import { extend, Button } from '../../../openseadragon';
import selectMode from '../actions/selectMode';

export default class Control {
  constructor(options, store, dispatcher) {
    // tooltip 은 화면 표시용(단축키 포함), mode 는 내부 모드 이름
    this.mode = (options.mode || options.tooltip).toUpperCase();
    this.store = store;
    this.dispatcher = dispatcher;
    this.btn = new Button(extend({
      onClick: this.onClick.bind(this),
    }, options));

    if (store.getMode() === this.mode) {
      this.activate();
    }

    this.changeHandler = () => {
      if (this.store.getMode() === this.mode) {
        this.activate();
      } else {
        this.deactivate();
      }
    };
    store.addHandler('CHANGE_EVENT', this.changeHandler);
  }

  activate() {
    this.btn.imgDown.style.visibility = 'visible';
  }

  deactivate() {
    this.btn.imgDown.style.visibility = 'hidden';
  }

  onClick(e) {
    selectMode(this.mode, this.dispatcher, this.store);
  }

  destroy() {
    if (this.store && this.changeHandler) {
      this.store.removeHandler?.('CHANGE_EVENT', this.changeHandler);
      this.changeHandler = null;
    }
  }
}